import ExpenseCategory from "./expense-category"
import Collection from "../../../data-structures/collection"
import {SortDirection} from "../../../data-structures/sort"

// const debug = "ExpenseCategoriesCollection"
const debug = false

export default class ExpenseCategoriesCollection extends Collection<ExpenseCategory> {

    constructor(models:any) {
        super(models);
    }

    static initFromJsonData(data: any[]) {
        const res = new ExpenseCategoriesCollection(_.map(data, (record) => new ExpenseCategory(record)))
        return res
    }

    resetAndKeepOldModels(models: ExpenseCategory[]) {
        const previousCollectionModels = _.clone(this.models)

        this.reset(models)

        // add models that are missing in new session Collection
        _.map(previousCollectionModels, model => {
            if (!this.get(model.id)) {
                this.add(model)
            }
        })
    }

    get active() {
        let expenseCategories = _.filter(this.models, (category)=>{
            return !category.isDeleted;
        })

        expenseCategories = _.orderBy(expenseCategories, [ec=>ec.sortPosition, ec=>ec.name], [SortDirection.ASC, SortDirection.ASC])

        return expenseCategories
    }

    get defaultCategoryId():ID|null {

        const activeCategories = this.active

        if (_.isEmpty(activeCategories)) return null

        return activeCategories[0].id
    }

    toOptions() {
        return _(this.models)
            .orderBy([ec=>ec.isDeleted ? 1 : 0, ec=>ec.sortPosition, ec=>ec.name], [SortDirection.ASC, SortDirection.ASC, SortDirection.ASC])
            .map((expenseCategory)=>{
                return expenseCategory.toOption()
            })
            .value()
    }

    activeToOptions() {
        return _.map(this.active, (expenseCategory)=>{
            return expenseCategory.toOption()
        })
    }

    // for Glist support
    public get items():any[] {
        return this.models
    }

}